import React from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
//import Form from "react-bootstrap/Form";
// import Button from "components/Button/Button";
//import CoverPhoto from "pages/City/CityInfo/CoverPhoto";
//import PlaceholderImage from "Assets/present-img.png";
import { org_friendly_url, searchUrl, apiUrl, myHeaders_With_Cache_Control } from "Api/Api";
import axios from 'axios';
//import { NavLink } from "react-router-dom";
import { local_routes, feature_names } from 'utils/Routes';
//import { get_current_unix_stamp } from 'utils/Helper';
import ActivityIndicator from "components/ActivityIndicator/ActivityIndicator";
//import Select from 'react-select';
import Table from "react-bootstrap/Table";
import TableHeader from "components/Table/TableHeader";
import UserTable from "components/UserTable/UserTable";

//import "../../City/CityInfo/style.css";
//import "../../CreateEvent/Steps/Presenters/style.css";

//import CreateUser from "components/CreateUser/CreateUser";
import CreateNewUserModalButton from 'components/Modals/CreateNewUserModalButton';

import UserContext from 'store/UserContext';

//import { asyncContainer, Typeahead } from 'react-bootstrap-typeahead';
//const AsyncTypeahead = asyncContainer(Typeahead);

class WorkspaceUsers extends React.Component {
    static contextType = UserContext;
    constructor(props) {
        super(props);
        this.pagination_limit = 100;
        this.default_pagination_from = 0;
        this.state = {
            createPresenterLoader: false,
            user_table_loading: true,
            add_user_section_loading: false,
            loading_users_typeahead: false,
            add_user_options: [],
            org_users: [],
            pagination_from: this.default_pagination_from,
            add_email_text: "",
            search_text: "",
            total_search_results: 0,
            showCreateUserComponent: false,
            userCollisionError: null,
            message: null,
            error_message: null
        };
        
        this.user_table_header_display = { 'Name': "", 'Email': "", 'View': "", 'Access Level': "" };

        // access_level - a little hacky        
        this.user_table_access_level_map = {
            'admin':`${feature_names.Workspace} Admin`,
            'normal':'Normal'
        };
        this.user_table_access_level_options = [];
        for (let access_level of Object.keys(this.user_table_access_level_map)) {
            let tmp_option_obj = {
                value: access_level,
                label: this.user_table_access_level_map[access_level]
            };
            this.user_table_access_level_options.push(tmp_option_obj);
        }

        this.workspace_base_url = "";
        //const { match: { params: { org_friendly_url } = {} } = {} } = this.props;
        if (org_friendly_url) {
          this.workspace_base_url = local_routes.workspace+"/"+org_friendly_url;
        }
    }

    componentDidMount = async function () {
        await this.getUsersFromApi();
    }

    getUsersFromApi = async (config = {}) => {
        let new_state = {...this.state};
        console.log("WorkspaceUsers getUsersFromApi config",config);
        console.log("WorkspaceUsers getUsersFromApi headers",myHeaders_With_Cache_Control);
        
        let query_filter = "all";
        if ('search_text' in config) {
            query_filter = config.search_text;
            new_state.search_text = config.search_text;
        } else if (this.state.search_text) {
            query_filter = this.state.search_text;
        }
        if (query_filter === "") {
            query_filter = "all";
        }
        
        let pagination_from = this.default_pagination_from;
        if ('pagination_from' in config) { // could be 0
            pagination_from = config.pagination_from;
            new_state.pagination_from = pagination_from;
        } else {
            pagination_from = this.state.pagination_from;
        }
        if (config.message) {
            new_state.message = config.message;
        } else {
            new_state.message = null;
        }
        if (config.error_message) {
            new_state.error_message = config.error_message;
        } else {
            new_state.error_message = null;
        }
        
        try {
            let [org_users_search_response,org_admin_users_response] = await Promise.all([
                axios.get(`${searchUrl}sitesearch?sort_by=entity_name&entity_type=users&q=${encodeURIComponent(query_filter)}&from=${pagination_from}&limit=${this.pagination_limit}`, myHeaders_With_Cache_Control),
                //axios.get(`${apiUrl}organizations/${this.props.org_data.entity_uuid}/users?attributes[0]=entity_uuid&shallow_filters[access_level][neq]=normal`, myHeaders_With_Cache_Control)
                axios.get(`${apiUrl}organizations/${this.props.org_data.entity_uuid}/users?attributes_array=${encodeURIComponent('["entity_uuid"]')}&shallow_filters_obj=${encodeURIComponent('{"access_level":{"neq":"normal"}}')}`, myHeaders_With_Cache_Control)
            ]);

            let search_query_results = org_users_search_response.data && org_users_search_response.data.search_query_results ? org_users_search_response.data.search_query_results : [];
            new_state.org_users = search_query_results.map((data) => data.entity_info);

            // insert users from add/create - necessary because "search" results might not contain new users yet
            if (config.insert_user) {
                new_state.insert_user = null;
                if (!new_state.org_users.find((item) => item.entity_uuid === config.insert_user.entity_uuid)) {
                    // not in new result yet - insert here
                    new_state.org_users.push(config.insert_user);
                    // now re-sort
                    new_state.org_users = new_state.org_users.sort((a, b) => (a.entity_name > b.entity_name) ? 1 : -1);
                }
            }

            // kind of hacky, but insert org access_level
            let admin_users_obj = {};
            for (let admin_user_obj of org_admin_users_response.data) {
                admin_users_obj[admin_user_obj.entity_uuid] = admin_user_obj.xref_data.access_level;
            }
            new_state.org_users = new_state.org_users.map((org_user_obj) => {
                if (admin_users_obj[org_user_obj.entity_uuid]) {
                    org_user_obj.access_level = admin_users_obj[org_user_obj.entity_uuid];
                } else {
                    org_user_obj.access_level = "normal";
                }
                let tmp_option_obj = {
                    value: org_user_obj.access_level,
                    label: this.user_table_access_level_map[org_user_obj.access_level]
                };
                org_user_obj.access_level_option = tmp_option_obj;
                return org_user_obj;
            });

            if (org_users_search_response.data && org_users_search_response.data.additional_information && 'total_search_results' in org_users_search_response.data.additional_information) {
                new_state.total_search_results = org_users_search_response.data.additional_information.total_search_results;
            }
            
            new_state.user_table_loading = false;
            new_state.add_user_section_loading = false;
            new_state.add_email_text = "";
 
            //console.log("WorkspaceInfo getUsersFromApi new_state",JSON.stringify(new_state,null,2));
            this.setState(new_state);
        } catch (err) {
            console.error("Search Error!",err);
            this.setState({user_table_loading:false,add_user_section_loading:false});
        }
    }

    // finish "CreateUser" component
    createNewUser = async (data,file = null) => {
        this.setState({ 
            createPresenterLoader: true,
            userCollisionError: null
        });
        
        console.log("createNewUser",data);
        if (data === undefined) {
            console.log("createNewUser no data");
            return;
        }
        let collison_check_obj = {
            email: data.email
        };
        
        //this.setState({
        //    add_user_section_loading:true
        //});
        
        let collision_check_response = await axios.post(`${apiUrl}users/checkUniqueCollision`, collison_check_obj);
        if (collision_check_response.data.email === true) {
            console.log("Found email collision");
            this.setState({
                userCollisionError: "Sorry, this email is already associated with an existing account",
                //add_user_section_loading:false
                createPresenterLoader: false
            });
            return;
        }
        //return;
        this.onClickToggleAddUser();
        
        this.setState({
            add_user_section_loading: true,
            createPresenterLoader: false
        });

        let callback_base_url = window.location.protocol + '//' + window.location.hostname + '/';
        data.callback_url = callback_base_url + 'resetpassword';
        data.link_base_url = callback_base_url;
        let friendly_url = `${data.firstname}-${data.lastname}`;
        data.friendly_url = friendly_url.toLowerCase().replace(/ /g, "-");

        data.custom_inviter_text = this.props.user_data.firstname + ' ' + this.props.user_data.lastname;
        data.custom_invitation_text = " to be part of the "+this.props.org_data.entity_name+" Team";
        
        console.log("New User data",data);

        // if we have profile pic, must treat this like a combined register/getUploadSignedUrl
        let new_user_response;
        if (file) {
            new_user_response = await axios.post(`${apiUrl}users/register/nopassword?asset_type=avatar_image&filename=${file.name}`, data);
            let upload_url = new_user_response.data.upload_url;
            let content_type = new_user_response.data.content_type;
            await this.uploadPutImage(file,upload_url,content_type);
        } else {
            new_user_response = await axios.post(`${apiUrl}users/register/nopassword`, data);
        }
        
        if (!new_user_response.data.entity_uuid) {
            this.setState({
                message: null,
                error_message: "ERROR creating new workspace user"
            })
        }
        
        // get new user data to display in table
        let response_data = await axios.get(`${apiUrl}users/${new_user_response.data.entity_uuid}`,myHeaders_With_Cache_Control);
        let user_data = response_data.data;
        
        user_data.entity_name = (user_data.firstname ? user_data.firstname+' ' : '')+(user_data.lastname || '');
        user_data.email = data.email;

       this.getUsersFromApi({
            message: 'New User '+data.email+' Created and Invitation Email Sent',
            error_message: null,
            pagination_from: 0,
            search_text: "",
            insert_user: user_data
        });
        
        /*
        // add new user to org_users array
        let tmp_org_users = [...this.state.org_users];
        tmp_org_users.push(user_data);
        
        // now we need to re-sort
        tmp_org_users = tmp_org_users.sort((a, b) => (a.entity_name > b.entity_name) ? 1 : -1);

        this.setState({
            org_users: tmp_org_users,
            message: 'New User '+this.state.add_email_text+' Created and Invitation Email Sent',
            error_message: null,
            add_user_section_loading: false,
            total_search_results: this.state.total_search_results + 1
        });
        */
        
        /*
        setTimeout(() => {
            window.scrollTo(0, 0);
            this.getUsersFromApi({message:'New User Created and Invitation Email Sent',error_message:null});
        }, 2000);
        */
    }

    // Button click Show Component
    onClickToggleAddUser = () => {
        this.setState({
            showCreateUserComponent: !this.state.showCreateUserComponent
        });
    }

    // for uploading (PUT) user profile pic
    uploadPutImage = async (file, upload_url, content_type) => {
        if (!file) {
            return;
        }
        const reader = new FileReader();
        reader.readAsDataURL(file);
        let profilePicPromise;
        // getting array buffer in profilePicPromise
        profilePicPromise = new Promise(resolve => {
            let reader = new FileReader();
            reader.readAsArrayBuffer(file);
            reader.onload = () => resolve(reader.result);
        });
        let profilePicPromise_response = await profilePicPromise;
        const config = {
            headers: { "Content-Type": content_type }
        };
        await axios.put(upload_url, profilePicPromise_response, config);
    }

    clearSearch = () => {
        this.setState({ user_table_loading: true });
        this.getUsersFromApi({pagination_from:0,search_text:""});
    }

    handleAddUser = async () => {
        let emailValid = this.state.add_email_text.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        if (!emailValid) {
            this.setState({
                error_message:this.state.add_email_text+' is an invalid email address',
                message: null
            });
            return;
        }

        this.setState({ message: null,
            error_message: null,
            add_user_section_loading: true
        });

        try {
            let response_data = await axios.get(`${apiUrl}users/getByEmail/${this.state.add_email_text}`,myHeaders_With_Cache_Control);
            let user_data = response_data.data;
            
            if (user_data.organizations_uuids && user_data.organizations_uuids.includes(this.props.org_data.entity_uuid)) {
                // already part of workspace!
                console.log("User "+this.state.add_email_text+" already part of workspace");
                this.setState({
                    add_user_section_loading: false,
                    error_message:'User with email address '+this.state.add_email_text+' ('+user_data.firstname+' '+user_data.lastname+') is already part of workspace',
                    message: null
                });
                return;
            }
            //this.setState({ user_table_loading: true });
            
            let user_uuid = user_data.entity_uuid;
            let org_uuid = this.props.org_data.entity_uuid;
            await axios.patch(`${apiUrl}organizations/${org_uuid}`, {
                "users": [
                    {
                        "xref_data": {
                            "access_level": "normal",
                        },
                        "entity_uuid": user_uuid,
                    }
                ]
            });
            
            // send team welcome email
            let custom_inviter_text = this.props.user_data.firstname + ' ' + this.props.user_data.lastname;
            let custom_invitation_text = " to be part of the "+this.props.org_data.entity_name+" Team";

            let post_obj = {
                user_uuid,
                email: this.state.add_email_text,
                custom_inviter_text,
                custom_invitation_text
            }
            await axios.post(`${apiUrl}users/sendTeamWelcomeEmail`,post_obj);
            
            // add pseudo entity_name field
            user_data.entity_name = (user_data.firstname ? user_data.firstname+' ' : '')+(user_data.lastname || '');
            
            /*
            let tmp_org_users = this.state.org_users;
            tmp_org_users.push(config.insert_user);
            // now re-sort
            tmp_org_users = tmp_org_users.sort((a, b) => (a.entity_name > b.entity_name) ? 1 : -1);
            this.setState({
               org_users: tmp_org_users,
               
            });
            */
            
            this.getUsersFromApi({
                message: 'User '+this.state.add_email_text+' Added to Workspace',
                error_message: null,
                pagination_from: 0,
                search_text: "",
                insert_user: user_data
            });
            
            /*
            // add new user to org_users array
            let tmp_org_users = [...this.state.org_users];
            tmp_org_users.push(user_data);
            
            // now we need to re-sort
            tmp_org_users = tmp_org_users.sort((a, b) => (a.entity_name > b.entity_name) ? 1 : -1);

            this.setState({
                org_users: tmp_org_users,
                message: 'User '+this.state.add_email_text+' Added to Workspace',
                error_message: null,
                add_user_section_loading: false,
                total_search_results: this.state.total_search_results + 1
            });
            */
            
            /*
            // sleep for 1 second so elasticsssearch gets updated
            setTimeout(() => {
                this.getUsersFromApi({message:'User '+this.state.add_email_text+' Added to Workspace',error_message:null});
                //this.setState({ add_email_text: null });
            }, 2000);
            */
        } catch (err) {
            // user not found!
            console.log("User "+this.state.add_email_text+" not found!");
            this.setState({
                add_user_section_loading: false,
                error_message:'User with email address '+this.state.add_email_text+' not found',
                message: null
            });
        }
    }

    updateUserAccessLevel = async (userData,selected_access_level_option) => {
        console.log("WorkspaceUsers updateUserAccessLevel",userData,selected_access_level_option);

        let patch_obj = {
            users: [
                {
                   entity_uuid: userData.entity_uuid,
                   xref_data: {
                       access_level: selected_access_level_option.value
                   }
                }
            ]
        };
        this.setState({message:'User Access Level Changed',error_message:null});
        await axios.patch(`${apiUrl}organizations/${this.props.org_data.entity_uuid}`,patch_obj);

    }

    removeUserFromWorkspace = async (userData) => {
        console.log("WorkspaceUsers removeUserFromWorkspace",userData);

        let tmp_org_users = [...this.state.org_users];
        tmp_org_users = tmp_org_users.filter(tmp_user => {
            if (tmp_user.entity_uuid === userData.entity_uuid) {
                return false;
            } else {
                return true;
            }
        });
        this.setState({
            error_message:null,
            message:`User Removed from ${feature_names.Workspace}`,
            org_users: tmp_org_users,
            total_search_results: this.state.total_search_results - 1
        });
        
        await axios.delete(`${apiUrl}organizations/${this.props.org_data.entity_uuid}/users/${userData.entity_uuid}`);
        
        // sleep for 1 second so elasticsssearch gets updated
        //setTimeout(() => {
        //    this.getUsersFromApi({message:'User Removed from Workspace'});
        //}, 2000);
    }

    showEditUser = (userData) => {
        console.log("WorkspaceUsers showEditUser");
    }

    checkForEnter = async (event) => {
        if (event.key === "Enter") {
            console.log("Enter pressed!");
            if (event.target.id === 'search_text') {
                this.setState({ user_table_loading: true });
                await this.getUsersFromApi({pagination_from:0,search_text:event.target.value});
            } else if (event.target.id === 'add_email_text') {
                await this.handleAddUser();
            }
        }
    }
    
    paginationHandler = async (e) => {
        console.log("paginationHandler",e.direction);
        
        let new_pagination_from = 0;
        if (e.direction === 'forward') {
            new_pagination_from = this.state.pagination_from + this.pagination_limit;
            // can't go past the end
            if (new_pagination_from >= this.state.total_search_results) {
                new_pagination_from = this.state.pagination_from;
            }
        } else if (e.direction === 'backward') {
            new_pagination_from = this.state.pagination_from - this.pagination_limit;
            // can't go below 0
            if (new_pagination_from < 0) {
                new_pagination_from = 0;
            }
        }
        this.setState({ user_table_loading: true });
        await this.getUsersFromApi({pagination_from:new_pagination_from});
    }

    handleChangeFilterValue = async (event) => {
        this.setState({
           [event.target.id]: event.target.value
        });
    }

    render() {
        
        if (this.state.add_user_section_loading) {
            return (
                <div className="presenters-info pkListContainer eventCreation">
                    <Row>
                        <Col lg={12}>
                            <br/>
                            <h1>{feature_names.Workspace} Users</h1>
                            <hr/>
                            <div className="createEventSpinner">
                                <ActivityIndicator theme="spinner" />
                            </div>
                        </Col>
                    </Row>
                </div>
            );
        }
        
        return (
            <div className="presenters-info pkListContainer eventCreation">
                <Row>
                    <Col lg={12}>
                        <br/>
                        <h1>{feature_names.Workspace} Users</h1>
                        <hr/>
                        <h4 style={{paddingTop:"10px",paddingBottom:"10px",fontSize:"smaller"}}>Add Current PK.com User to {feature_names.Workspace}</h4>
                        <Row>
                            <Col>
                                
                                <div className="search-nav">
                                    <i className="fa fa-search-plus nav-search"></i>
                                    <input
                                                style={{border:"1px solid #d7d8da"}}
                                                type="text"
                                                autoFocus
                                                value={this.state.add_email_text}
                                                id="add_email_text"
                                                onChange={this.handleChangeFilterValue}
                                                onKeyPress={this.checkForEnter}
                                                placeholder={`Enter an Email Address`}
                                    />
                                </div>
                            </Col>
                            <Col>
                                <button style={{marginTop:"0px"}} className="btn-global btn-green Form_Btn_Pad font-normal marTop5 table-buttons" onClick={this.handleAddUser}>
                                    Add
                                </button>
                            </Col>
                        </Row>
                        <hr/>
                            {/*
                            <AsyncTypeahead
                                id='UserTypeAhead'
                                labelKey={(option) => `${option.entity_name} - ${option.friendly_url}`}
                                isLoading={this.state.loading_users_typeahead}

                                filterBy={['typed_query','entity_name','friendly_url']}
                                placeholder="Search All PechaKucha Users"

                                ref={(typeahead) => this.typeahead = typeahead}
                                minLength={3}
                                onChange={this.onAddUserChange}

                                onSearch={this.handleTypeHeadSearch}
                                options={this.state.add_user_options} />
                            */}
                        <br/>
                        <Row>
                            <Col>
                            <div className="add-newVenue venueAlign">
                                
                                {/*
                                <Button
                                    theme="btn-global btn-green Form_Btn_Pad font-normal marTop5 table-buttons"
                                    OnClickMet={this.onClickToggleAddUser}
                                >
                                    Create a New {this.props.org_data.entity_name} PechaKucha.com Account
                                </Button>
                                
                                
                                {this.state.showCreateUserComponent &&
                                    <CreateUser
                                        createPresenterLoader={this.state.createPresenterLoader}
                                        org_data={this.props.org_data}
                                        user_data={this.props.user_data}
                                        finishCreateUser={this.createNewUser}
                                        onClickCancelCreateUser={this.onClickToggleAddUser}
                                        userCollisionError={this.state.userCollisionError}
                                    />
                                }
                                */}

                                
                                <CreateNewUserModalButton
                                    //org_data={this.props.org_data}
                                    custom_invitation_text={" to be part of the "+this.props.org_data.entity_name+" Team"}
                                    //user_data={this.props.user_data}
                                    //OnFinishCreateUser={this.createNewUser}
                                    OnFinishCreateUser={this.getUsersFromApi}
                                    //userCollisionError={this.state.userCollisionError}
                                    button_text={`Create a New ${this.props.org_data.entity_name} PechaKucha.com Account`}
                                />
                                

                            </div>
                            </Col>
                        </Row>
                    
                        <hr/>
                        <br/>
                        <Row>
                            <Col>
                                <div className="search-nav">
                                    <i className="fa fa-search nav-search"></i>
                                    <input
                                        style={{border:"1px solid #d7d8da"}}
                                        type="text"
                                        autoFocus
                                        value={this.state.search_text}
                                        id="search_text"
                                        onChange={this.handleChangeFilterValue}
                                        onKeyPress={this.checkForEnter}
                                        placeholder={`Search/Filter Current ${this.props.org_data.entity_name} Users`}
                                    />
                                </div>
                            </Col>
                            <Col>
                                <button style={{marginTop:"0px"}} className="btn-global btn-green Form_Btn_Pad font-normal marTop5 table-buttons" onClick={this.clearSearch}>
                                    Clear Search and Refresh
                                </button>
                            </Col>
                        </Row>

                        { this.state.user_table_loading &&
                        <div className="createEventSpinner">
                            <ActivityIndicator theme="spinner" />
                        </div>
                        }
                        { !this.state.user_table_loading &&
                        <React.Fragment>
                            { this.state.message &&
                            <span style={{color:"green", paddingTop: "10px"}}><br/>{this.state.message}</span>
                            }
                            { this.state.error_message &&
                            <span style={{color:"red", paddingTop: "10px"}}><br/>{this.state.error_message}</span>
                            }
                            <p className="related-name" style={{float:'right'}}>
                                { this.state.pagination_from > 0 &&
                                    <span style={{cursor:"pointer"}} onClick={() => {this.paginationHandler({direction:'backward'})}}>Previous</span>
                                }
                                { (this.state.pagination_from + this.pagination_limit) < this.state.total_search_results && 
                                    <span style={{marginLeft:"20px",cursor:"pointer"}} onClick={() => {this.paginationHandler({direction:'forward'})}}>Next</span>
                                }
                            </p>
                            <div className="table-boby">
                                <Table variant={this.context.theme} responsive={true}>
                                    <tbody>
                                        {/* Pending section header*/}
                                        <TableHeader
                                            headerType="Users"
                                            tableHeader={this.user_table_header_display}
                                            listLength={this.state.total_search_results}
                                        />
                                        {/* Pending section Body*/}
    
                                        {this.state.org_users.map((item, i) => {
                                            return (
                                                <UserTable
                                                    key={i}
                                                    userData={item}
                                                    workspace_base_url={this.workspace_base_url}
                                                    //OnEditUser={this.showEditUser}
                                                    OnRemoveUser={this.removeUserFromWorkspace}
                                                    OnChangeDropdown={this.updateUserAccessLevel}
                                                    dropdown_options={this.user_table_access_level_options}
                                                />
                                            );
                                        })}
                                    </tbody>
                                </Table>
                            </div>
                        </React.Fragment>
                        }
                    </Col>
                    
                </Row>
            </div>
        );
        

    }
}

export default WorkspaceUsers;
